import React from "react";

export const Tooltip = ({ description }) => {
  return (
    <div className="tooltip !ml-1 !mb-1 ">
      <span className="question-mark !font-[20px] !pt-1 !pb-1 !pl-[6px] !pr-[6px] !bg-gray-200">?</span>
      <span className="tooltiptext">{description}</span>
    </div>
  );
};
